import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

import Icon from '@rio-cloud/rio-uikit/Icon';

import { icons, getIconNames } from '../../../utils/icons';

const humanIcons = [...getIconNames(icons.humans)] as string[];

export const IconAnimated = () => (
    <div className='uikit-icons'>
        <Headline headlineType='h3' anchor='animatedIcons'>
            Animated icons
        </Headline>
        <Playground example={iconAnimatedIconsExample} />
    </div>
);

const iconAnimatedIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Spinning icons</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='uikit-icon icon-refresh spinning text-size-150pct' />
                <span className='uikit-icon icon-climate-control spinning text-size-150pct' />
                <span className='uikit-icon icon-cog spinning text-size-150pct' />
                <span className='uikit-icon icon-spinner spinning text-size-150pct' />
                <span className='uikit-icon icon-tire spinning text-size-150pct' />
            </div>
        </div>
        <div>
            <Title>Pulsing icons</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                {humanIcons.map(icon => (
                    <span className={`uikit-icon ${icon} pulsing text-size-150pct`} key={icon} />
                ))}
            </div>
        </div>
        <div>
            <Title>Hover icons</Title>
            <div className='display-flex flex-wrap gap-10 align-items-center'>
                <Icon iconName='trash' hoverIconName='trash-open' size='h2' />
                <Icon
                    iconName='filling-station'
                    pairIconName='play'
                    hoverPairIconName='pause'
                    size='h2'
                    className='cursor-pointer'
                />
            </div>
        </div>
    </div>
);
